var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/column/column.tsx";
import React from 'react';
import { useHistory } from 'react-router-dom';
import Helmet from 'soapbox/components/helmet';
import { useSoapboxConfig } from 'soapbox/hooks';
import { Card, CardBody, CardHeader, CardTitle } from '../card/card';

/** A backdrop for the main section of the UI. */
const Column = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    backHref,
    children,
    label,
    transparent = false,
    withHeader = true,
    className
  } = props;
  const history = useHistory();
  const soapboxConfig = useSoapboxConfig();

  const handleBackClick = () => {
    if (backHref) {
      history.push(backHref);
      return;
    }

    if (history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  const renderChildren = () => /*#__PURE__*/React.createElement(Card, {
    variant: transparent ? undefined : 'rounded',
    className: className,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, withHeader ? /*#__PURE__*/React.createElement(CardHeader, {
    onBackClick: handleBackClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(CardTitle, {
    title: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  })) : null, /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }, children));

  return /*#__PURE__*/React.createElement("div", {
    role: "region",
    className: "relative",
    ref: ref,
    "aria-label": label,
    "column-type": transparent ? 'transparent' : 'filled',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Helmet, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, label), soapboxConfig.appleAppId && /*#__PURE__*/React.createElement("meta", {
    "data-react-helmet": "true",
    name: "apple-itunes-app",
    content: "app-id=".concat(soapboxConfig.appleAppId, ", app-argument=").concat(location.href),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 11
    }
  })), renderChildren());
});
export default Column;